import { render, staticRenderFns } from "./BetgamePrivacy.vue?vue&type=template&id=a1a20eae&scoped=true"
import script from "./BetgamePrivacy.vue?vue&type=script&lang=js"
export * from "./BetgamePrivacy.vue?vue&type=script&lang=js"
import style0 from "./BetgamePrivacy.vue?vue&type=style&index=0&id=a1a20eae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a20eae",
  null
  
)

export default component.exports